import Invoice from 'layouts/pages/finantial/invoice';
import GeneralDashboard from 'layouts/pages/finantial/dashboard';
import Consolidados from 'layouts/pages/finantial/consolidados';
import OrderList from 'layouts/pages/orders/order-list';
import Clients from 'layouts/pages/system/clients';
import Agents from 'layouts/pages/system/agents';
import Providers from 'layouts/pages/system/providers';
import Moneda from 'layouts/pages/system/moneda';
import Users from 'layouts/pages/system/users';
import OrderAdd from 'layouts/pages/orders/order-add';
import OrderTrack from 'layouts/pages/orders/order-track';
import OrderDocuments from 'layouts/pages/orders/order-documents';
import OrderDocumentShipments from 'layouts/pages/orders/order-shipment-documents';
import OrderTrafficShipments from 'layouts/pages/orders/order-shipment-traffic';
import OrderShipments from 'layouts/pages/orders/order-shipment';
import InvoiceList from 'layouts/pages/finantial/invoice-list';
import SignInCover from 'layouts/authentication/sign-in/cover';
import SettingsIcon from 'prefabsComponents/Icons/Settings';
import Document from 'prefabsComponents/Icons/Document';
import CreditCard from 'prefabsComponents/Icons/CreditCard';
import Roles from 'layouts/pages/system/roles';
import Profiles from 'layouts/pages/system/profiles';

const routes = [
    { type: 'title', title: 'Logistica', key: 'title-logistica' },
    {
        type: 'collapse',
        name: 'Logistica',
        key: 'Logistica',
        icon: <Document size="12px" />,
        collapse: [
            {
                name: 'Orden de Compra',
                key: 'Ordenes',
                route: 'ordenes/',
                component: <OrderList />,
                protected: true,
                visible: true
            },
            {
                name: 'Warehouses Recipts',
                key: 'Warehouses',
                route: 'warehouses/',
                component: <OrderList />,
                protected: true,
                visible: false
            },
            {
                name: 'Reservas',
                key: 'Reservas',
                route: 'reservas/',
                component: <OrderList />,
                protected: true,
                visible: false
            },
            {
                name: 'Waybills',
                key: 'Waybills',
                route: 'waybills/',
                component: <OrderList />,
                protected: true,
                visible: false
            },
            {
                name: 'Bill of Lading',
                key: 'BL',
                route: 'bill-of-lading/',
                component: <OrderList />,
                protected: true,
                visible: false
            },
        ],
    },
    { type: 'title', title: 'Finanzas', key: 'title-finanzas' },
    {
        type: 'collapse',
        name: 'Finanzas',
        key: 'Finanzas',
        icon: <CreditCard size="12px" />,
        collapse: [
            {
                name: 'Cotizaciones',
                key: 'Cotizaciones',
                route: 'finanzas/cotizaciones',
                component: <InvoiceList />,
                protected: true,
                visible: false,
                roles: ['admin','user']
            },
            {
                name: 'Cobranzas',
                key: 'Cobranzas',
                route: 'finanzas/cobranzas',
                component: <InvoiceList />,
                protected: true,
                visible: true
            },
            {
                name: 'Reportes',
                key: 'Reportes',
                route: 'finanzas/reportes',
                component: <GeneralDashboard />,
                protected: true,
                visible: true,
                roles: ['admin','user']
            },
            {
                name: 'Liquidacion Consolidados',
                key: 'Consolidados',
                route: 'finanzas/consolidados',
                component: <Consolidados />,
                protected: true,
                visible: true,
                roles: ['admin','user']
            },
        ],
    },
    { type: 'title', title: 'Sistema', key: 'title-mantenedores', roles: ['admin','user'] },
    {
        type: 'collapse',
        name: 'Mantenedores',
        key: 'Mantenedores',
        roles: ['admin','user'],
        icon: <SettingsIcon size="12px" />,
        collapse: [
            {
                name: 'Clientes',
                key: 'Clientes',
                route: '/mantenedores/clientes',
                component: <Clients />,
                protected: true,
                visible: true
            },
            {
                name: 'Proveedores',
                key: 'Proveedores',
                route: '/mantenedores/proveedores',
                component: <Providers />,
                protected: true,
                visible: true
            },
            {
                name: 'Moneda',
                key: 'Moneda',
                route: '/mantenedores/moneda',
                component: <Moneda />,
                protected: true,
                visible: true
            },
            {
                name: 'Agente',
                key: 'Agente',
                route: '/mantenedores/agente',
                component: <Agents />,
                protected: true,
                visible: true
            },
            {
                name: 'Usuarios',
                key: 'Usuarios',
                route: '/mantenedores/usuarios',
                component: <Users />,
                protected: true,
                visible: true
            },
            {
                name: 'Cargos',
                key: 'Cargos',
                route: '/mantenedores/cargos',
                component: <Roles />,
                protected: true,
                visible: true
            },
            {
                name: 'Perfiles',
                key: 'Perfiles',
                route: '/mantenedores/perfiles',
                component: <Profiles />,
                protected: true,
                visible: true
            },
            {
                name: 'Permisos',
                key: 'Permisos',
                route: '/mantenedores/permisos',
                component: <GeneralDashboard />,
                protected: true,
                visible: true
            },
            {
                name: 'Configuracion',
                key: 'Configuracion',
                route: '/pages/configuracion',
                component: <GeneralDashboard />,
                protected: true,
                visible: true
            },
        ],
    },

    { route: '/ordenes/nueva', component: <OrderAdd />, protected: true },
    {
        route: '/finanzas/cobranzas/nueva',
        component: <Invoice />,
        protected: true,
    },
    {
        route: '/ordenes/seguimiento',
        component: <OrderTrack />,
        protected: true,
    },
    {
        route: '/ordenes/documentos/:numeroOrdenCabecera',
        component: <OrderDocuments />,
        protected: true,
    }, // Ruta con parámetro dinámico
    {
        route: '/ordenes/embarques/:numeroOrdenCabecera',
        component: <OrderShipments />,
        protected: true,
    }, // Ruta con parámetro dinámico
    {
        route: '/ordenes/:numeroOrdenCabecera/embarques/:idOrdenDetalle/documentos',
        component: <OrderDocumentShipments />,
        protected: true,
    }, // Ruta con parámetro dinámico
    {
        route: '/ordenes/embarques/traficos/:numeroOrdenDetalle',
        component: <OrderTrafficShipments />,
        protected: true,
    }, // Ruta con parámetro dinámico
    { route: '/login', component: <SignInCover />, protected: false },
];

export default routes;
